<template>
    <div class="pg-popover-wrapper">
        <h3>Edytuj lokal i rolę:</h3>

        <div class="inner-padding">
            <form class="form form-change-place-role" @submit.prevent="postChangePlaceRole" style="margin-bottom: 15px">
                <span v-if="loading"><span class="loader gold"></span></span>
                <div class="form-group" v-if="places.length > 0 && !loading">
                    <div class="select-wrapper">
                        <span v-if="form.place_slug === null" class="select-placeholder">Wybierz lokal</span>
                        <select v-model="form.place_slug" required>
                            <option v-for="item in places">{{ item.slug }}</option>
                        </select>
                    </div>
                    <p class="error" v-if="errors.place_slug">{{ errors.place_slug[0] }}</p>
                </div>
                <p v-if="places.length == 0 && !loading">Brak lokali do wyboru.</p>
                <div class="form-group">
                    <div class="select-wrapper">
                        <span v-if="form.role_slug === null" class="select-placeholder">Wybierz rolę</span>
                        <select v-model="form.role_slug" required>
                            <option v-for="item in roles" :value="item.slug">{{ item.name }}</option>
                        </select>
                    </div>
                    <p class="error" v-if="errors.role_slug">{{ errors.role_slug[0] }}</p>
                </div>
                <ion-button mode="ios" size="medium" fill="outline" type="submit" :disabled="loading">
                    <span v-if="loading"><span class="loader"></span></span>
                    <span v-else>Zapisz zmiany</span>
                </ion-button>
            </form>
        </div>

    </div>
</template>

<script>
    import api from '@/services/Api';
    // this component has no access to store via import
    // instead pass store as props
    export default {
        name: 'ChangePlaceRolePopover',
        props: ['store','item', 'place_slug_original', 'roles', 'employee', 'employee_slug'],
        data() {
            return {
                loading: false,
                places: [],
                form: {
                    place_slug: '',
                    role_slug: ''
                },
            }
        },
        computed: {
            errors(){
                return this.store.state.employees.errors
            }
        },
        mounted() {
            this.form = this.item;
            this.form.place_slug_original = this.place_slug_original;
            this.getUserPlaces(this.item.place_slug);
        },
        methods: {
            getUserPlaces(slug){
                this.loading = true;
                let url = '/users/places/'+ slug
                api({url: url, method: 'GET'})
                    .then(resp => {
                        this.loading = false;
                        this.places = resp.data.data
                    })
            },
            postChangePlaceRole() {
                let payload = {'employee_slug': this.employee_slug, 'data': this.form};
                this.store.dispatch('employees/USER_EMPLOYEE_UPDATE_REQUEST', payload).then(resp => {
                    this.dismissPopover();
                    this.store.dispatch('GLOBAL_TOAST','Zaktualizowano poprawnie.');
                });
            },
            dismissPopover() {
                return this.$ionic.popoverController.dismiss()
            }
        }
    }
</script>